module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-stone-path-background-remnants.5cf6505a.png";